module.exports = __webpack_public_path__ + "img/96.cf2e3d42.jpg";